import type { AppThemeMode } from './index';

export const THEME_MODE_STORAGE_KEY = 'app-theme-mode';

export const getInitialThemeMode = (): AppThemeMode => {
  const savedMode = localStorage.getItem(THEME_MODE_STORAGE_KEY);
  if (savedMode === 'dark' || savedMode === 'light') {
    return savedMode;
  }

  // Fall back to the user's OS/browser preference when no app setting is saved.
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

// Starts a MutationObserver that guards against scripts setting `overflow`/`overflow-y` to `hidden`.
// Returns a cleanup function that disconnects the observer. Safe to call on server (no-op).
export function startBodyOverflowObserver(): () => void {
  if (typeof document === 'undefined' || !document.body) return () => {};

  const obs = new MutationObserver(() => {
    try {
      const overflow = document.body.style.getPropertyValue('overflow');
      const overflowY = document.body.style.getPropertyValue('overflow-y');
      if ((overflow === 'hidden' || overflowY === 'hidden') && overflowY !== 'scroll') {
        document.body.style.setProperty('overflow-y', 'scroll', 'important');
      }
    } catch (e) {
      console.warn('Failed to enforce scroll on body overflow change', e);
    }
  });

  obs.observe(document.body, { attributes: true, attributeFilter: ['style'] });
  return () => obs.disconnect();
}
